
import Vue from "vue";
export default Vue.extend({
  name: "overlay-progress-circular",
  props: {
    color: {
      type: String,
      required: false,
      default: "info"
    },
    size: {
      type: Number,
      required: false,
      default: 32
    },
    width: {
      type: Number,
      required: false,
      default: 4
    },
    value: {
      type: Boolean,
      required: false,
      default: true
    },
    absolute: {
      type: Boolean,
      required: false,
      default: false
    }
  }
});
